import _ from 'lodash';
import Vue from 'vue';
// @ts-ignore
import vueQr from 'vue-qr';
import { ResponseCode } from '~/util/constant';
import { TraceCode } from '~/util/trace';

let timer: NodeJS.Timeout;

export default Vue.extend({
    components: {
        vueQr,
    },
    data(): Record<string, any> {
        return {
            mode: '',
            payType: 'alipay',
            showQrcode: false,
            ticket: {},
            type: '', // 门票类型 1单日票  2展期票
            fair: {},
            fairId: '',
            payStatus: '', // 支付状态 1-未支付 2-已支付 3-已提交 4-已完成
            orderNo: '',
            orderId: '',
            num: 1,
            code: {},
        };
    },
    created() {
        if (this.mode === 'ticket') {
            this.getPayStatus();
        }
    },
    methods: {
        async toPay() {
            let res: any;
            this.$data.disabled = true;
            if (this.payType === 'alipay') {
                // res = await this.getQRcode(1);
                res = await this.rePayment(1);
                const div = document.createElement('div');
                /* 下面的data.content就是后台返回接收到的数据 */
                div.innerHTML = res.data.body;
                div.id = 'alipay';
                document.body.appendChild(div);
                try {
                    // @ts-ignore
                    document
                        .querySelector('#alipay')
                        .querySelector('form')
                        .submit();
                    // 埋点
                    window.trace?.upload({
                        module: TraceCode.MO_FAIR_TICKET,
                        bizId: this.fairId,
                        bizOrderId: this.orderNo,
                        callbackCode: TraceCode.CC_TO_ALIPAY_TICKET,
                        success: TraceCode.SUCCESS,
                    });
                } catch (error) {
                    if (process.client && 'fundebug' in window) {
                        window.fundebug.notifyError(
                            `${error}-pay/pay-ticket-mixin-60`
                        );
                    }
                    console.error(error);
                    this.$router.push(
                        `/result/error/?id=${this.fairId}&orderNo=${this.orderNo}`
                    );
                    // 埋点
                    window.trace?.upload({
                        module: TraceCode.MO_FAIR_TICKET,
                        bizId: this.fairId,
                        bizOrderId: this.orderNo,
                        callbackCode: TraceCode.CC_TO_ALIPAY_TICKET,
                        success: TraceCode.FAIL,
                    });
                }
            } else if (this.payType === 'wxpay') {
                // res = await this.getQRcode(2);
                res = await this.rePayment(2);
                if (res.code === ResponseCode.SUCCESS) {
                    this.showQrcode = true;
                    this.code = res.data;
                    // 埋点
                    window.trace?.upload({
                        module: TraceCode.MO_FAIR_TICKET,
                        bizId: this.fairId,
                        bizOrderId: this.orderNo,
                        callbackCode: TraceCode.CC_TO_WXPAY_TICKET,
                        success: TraceCode.SUCCESS,
                    });
                } else {
                    // 埋点
                    window.trace?.upload({
                        module: TraceCode.MO_FAIR_TICKET,
                        bizId: this.fairId,
                        bizOrderId: this.orderNo,
                        callbackCode: TraceCode.CC_TO_WXPAY_TICKET,
                        success: TraceCode.FAIL,
                    });
                }
            }
            if (res.code === ResponseCode.SUCCESS) {
                if (timer) {
                    clearTimeout(timer);
                }
                this.getPayStatus();
            } else {
                this.$message.error('发起支付失败，请重试或联系客服。');
            }
            this.$data.disabled = false;
        },
        // 获取二维码 type: 0-积分兑换 1-PC支付宝支付 2-PC微信支付 3-小程序微信支付
        async getQRcode(type: number) {
            const { exhibitionId, exhibitionName } = this.fair as Record<
                string,
                any
            >;
            return await this.$axios.post('/api/pay/createPreOrder', {
                exhibitionId,
                exhibitionName,
                num: this.num,
                payType: type,
                price: this.$data.price,
                ticketType: this.type || this.ticketType,
                type: 1, // 门票
                orderNo: this.orderNo,
            });
        },
        // 重新付款
        async rePayment(type: number) {
            return await this.$axios.post('/api/ticketOrderApi/rePayment', {
                id: this.orderId,
                payType: type,
            });
        },
        async getPayStatus() {
            const res: any = await this.$axios.get(
                `/api/pay/queryOrderStatusByOrderNo/${this.orderNo}`
            );
            if (res.code === ResponseCode.SUCCESS) {
                this.payStatus = _.get(res, 'data.OrderStatus', 0);
                if (_.get(res, 'data.OrderStatus', null) === 3) {
                    clearTimeout(timer);
                    this.$router.push(
                        `/result/success/?id=${this.fairId}&orderNo=${this.orderNo}`
                    );
                    // this.handleClose();
                    // this.orderData = res.data;
                    // @ts-ignore
                    // this.$parent.showOrderInfo(res.data);
                } else if (_.get(res, 'data.OrderStatus', 0) === 1) {
                    if (this.payType === 'wxpay') {
                        timer = setTimeout(() => {
                            this.getPayStatus();
                        }, 1000);
                    }
                }
            }
        },
    },
});
